import React, { useContext } from "react";
import { useSearchParams, Navigate, useParams, generatePath } from "react-router-dom";
import track from "react-tracking";

import { Flex } from "@chakra-ui/react";

import CheckoutFormView from "components/Trips/Checkout/CheckoutForm/CheckoutFormView";
import { PAGE_PATHS } from "config/routes";
import { SessionContext } from "contexts";
import { Loader } from "elements";
import useFetchOffers from "hooks/api/offers/useFetchOffers";
import { Offer } from "models/Offers";
import { PRODUCTS_NAME } from "types/products";
import { usePageTracking } from "utils/tracking";

const CheckoutPage = () => {
  usePageTracking();

  const { user } = useContext(SessionContext);
  const { token } = useParams();
  const [searchParams] = useSearchParams();

  const { isLoading: isLoadingOffers, data: offersData } = useFetchOffers({ enabled: !!user });

  const productName = searchParams.get("product-name") as PRODUCTS_NAME;

  if (!productName) {
    return <Navigate to={{ pathname: generatePath(PAGE_PATHS.HOME_PAGE) }} />;
  }

  if (isLoadingOffers) {
    return (
      <Flex justifyContent="flex-center" alignItems="center" height="100%" mx="auto">
        <Loader dataTestId="loader" />
      </Flex>
    );
  }

  if (!offersData) {
    switch (productName) {
      case PRODUCTS_NAME.AIR_BUNDLE_MEMBERSHIP_ESSENTIAL_ANNUALLY:
        return (
          <Navigate
            to={{
              pathname: generatePath(PAGE_PATHS.TRIPS.UPGRADE.ANNUAL_PAGE, { token: token?.toString() || "" }),
              search: searchParams.toString(),
            }}
          />
        );
      case PRODUCTS_NAME.UPGRADE_TO_TRIP_COMPLETE:
        return (
          <Navigate
            to={{
              pathname: generatePath(PAGE_PATHS.TRIPS.UPGRADE.COMPLETE_PAGE, { token: token?.toString() || "" }),
              search: searchParams.toString(),
            }}
          />
        );
      default:
        return null;
    }
  }

  const offers = offersData.offers as Record<string, Offer>;

  return <CheckoutFormView productName={productName} offers={offers} />;
};

export default track({ page_type: "Trips.Upgrade.Checkout" })(CheckoutPage);
